import getUseridService from '../services/components/get_userid.jsx'


const getState = (userIdState) => ({ type: "GET_USERID", userIdState })


export const getUseridAction = (cardNumber) => dispatch => {
    let state = [];

    getUseridService((data, msg ) => {

        if (msg === "success") {

            state = {
                status: 200,
                body: data
            }
        } else {
            state = data
        }
        dispatch(getState(state))
    },cardNumber)
} 


// WEBPACK FOOTER //
// ./src/actions/getUserid.jsx